import { useTranslation } from "react-i18next";

import type { SessionConfigFiltersType } from "@configs/custom-app-config-schema";
import i18n from "@helpers/lib/i18n";
import { formatCount, formatNumber } from "@memorang/helpers/src/common";
import type { Distribution } from "@memorang/types/src/content";
import Box from "@memorang/ui/src/components/Box";
import CustomListSubheaderContainer from "components/CustomListSubheaderContainer";
import type { CheckboxState } from "../types/filter";
/* -----------------Child components--------------- */
import CheckboxListItem, { type BgColorType } from "./CheckboxListItem";

interface Props {
	selectedCheckboxMap?: Record<string, boolean>;
	handleSelectCheckbox: (checkboxState: CheckboxState) => void;
	distribution: Distribution;
	disableAll?: boolean;
	hasAccess?: boolean;
	distributionFilterItems: SessionConfigFiltersType;
	handleShowPurchase: () => void;
}
const DistributionFilterList = ({
	selectedCheckboxMap,
	handleSelectCheckbox,
	distribution,
	disableAll,
	hasAccess,
	distributionFilterItems,
	handleShowPurchase,
}: Props) => {
	const { t } = useTranslation();
	const interceptSelectCheckbox = (distkey: string) => {
		const newCheckboxMap = {
			...(selectedCheckboxMap || {}),
			[distkey]: !selectedCheckboxMap?.[distkey],
		};
		handleSelectCheckbox(newCheckboxMap);
	};

	return (
		<Box>
			<CustomListSubheaderContainer enableGutters>
				{t("sessionConfig.mastery")}
			</CustomListSubheaderContainer>
			{distributionFilterItems.map(({ distKey, color, label }, index) => {
				const status = selectedCheckboxMap?.[distKey] ? "checked" : "unchecked";
				const count = distribution[distKey];
				return (
					<CheckboxListItem
						title={
							label ? label[i18n.language] : t(`mastery.labels.${distKey}`)
						}
						key={distKey}
						disableAll={disableAll}
						status={status}
						color={color}
						rightText={`${formatNumber(count)} ${formatCount(t("common.item"), count)}`}
						bgColorType={distKey as BgColorType}
						handleSelectCheckbox={() =>
							hasAccess
								? interceptSelectCheckbox(distKey)
								: handleShowPurchase()
						}
						testID={`mastery-checkbox-${index}`}
						locked={!hasAccess}
					/>
				);
			})}
		</Box>
	);
};

export default DistributionFilterList;
